import React, { useState } from 'react';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import { Body } from '../../../../UI/Elements';

export const LocationList = ({
  activeStoreIndex,
  createPopUp,
  currentZoom,
  list,
  map,
  onClick,
  removePopup,
  setActiveStoreIndex,
  noResultBody,
  zoomBody,
}) => {
  const [isHover, setIsHover] = useState(false);

  const handleOnClick = (store, index) => {
    onClick(store, index);
  };

  return (
    <>
      {list.length > 0 && currentZoom > 9 ? (
        list.map((store, i) => {
          const prop = store.properties;
          const isStoreActive = activeStoreIndex === i;
          const distanceInKm = `${Math.round(prop.distance * 100) / 100} km`;

          const HandleMouseEnter = () => {
            if (currentZoom > 13) {
              createPopUp(map, store);
            }
            setIsHover(true);
            setActiveStoreIndex(i);
          };

          const HandleMouseLeave = () => {
            setIsHover(false);
            setActiveStoreIndex(null);
            removePopup();
          };

          const handleItemClick = () => {
            removePopup();
            handleOnClick(store, i);
          };

          return (
            <button
              type='button'
              className='w-full flex justify-between p-6 cursor-pointer border-b hover:bg-gray-200'
              onMouseEnter={HandleMouseEnter}
              onMouseLeave={HandleMouseLeave}
              id={`listing-${prop.id}`}
              isActive={isStoreActive}
              onClick={handleItemClick}>
              <div className='w-full flex justify-between'>
                <div className='w-4/5 text-left'>
                  <Label
                    text={prop.name}
                    weight='medium'
                    gutterBottom
                  />
                  <Label
                    color={{ classname: 'gray-500' }}
                    size='sm'
                    text={`${prop.address1}, ${prop.postcode}, ${
                      prop.city
                    },${' '}${prop.state && `${prop.state}, `}${prop.country}`}
                  />
                </div>
                <div
                  className='flex items-center'
                  isHover={isHover}
                  isStoreActive={isStoreActive}>
                  {isHover && isStoreActive ? (
                    <Icon iconKey='FaArrowRight' />
                  ) : (
                    <Label
                      size='sm'
                      color={{ classname: 'gray-500' }}
                      text={prop.distance && distanceInKm}
                    />
                  )}
                </div>
              </div>
            </button>
          );
        })
      ) : list.length === 0 ? (
        <div className='flex flex-col justify-center items-center p-6 text-center h-full'>
          <div className='pb-6'>
            <Icon
              size='3xl'
              iconKey='HiOutlineSearch'
              color={{ classname: 'gray-500' }}
            />
          </div>
          <Body {...noResultBody} />
        </div>
      ) : (
        <div className='flex flex-col justify-center items-center p-6 text-center h-full'>
          <div className='pb-6'>
            <Icon
              size='3xl'
              iconKey='MdZoomOutMap'
              color={{ classname: 'gray-500' }}
            />
          </div>
          <Body {...zoomBody} />
        </div>
      )}
    </>
  );
};
